import styled from "styled-components";

const ContactForm7IntegrationPageStyled = styled.div``;
const ConnectorWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
`;
const ArrowSeparatorStyled = styled.div`
  margin: 0 20px;
  align-self: flex-end;
  padding-bottom: 11px;
`;
export {
  ContactForm7IntegrationPageStyled,
  ConnectorWrapperStyled,
  ArrowSeparatorStyled
};
